
export interface AppConfig {
  AWS_RUM_APP_ID: string;
  AWS_RUM_POOL_ID: string;
  CASE_API_URL: string;
  USER_POOL_ID: string;
  USER_POOL_CLIENT_ID: string;
  GA4_TRACKING_ID: string;
  ENV: string;
  REGION: string;
}

export function getAppConfig(): AppConfig {
  return {
    AWS_RUM_APP_ID: import.meta.env.VITE_AWS_RUM_APP_ID,
    AWS_RUM_POOL_ID: import.meta.env.VITE_AWS_RUM_POOL_ID,
    CASE_API_URL: import.meta.env.VITE_CASE_API_URL,
    USER_POOL_ID: import.meta.env.VITE_USER_POOL_ID,
    ENV: import.meta.env.VITE_ENV || '',
    GA4_TRACKING_ID: import.meta.env.VITE_GA4_TRACKING_ID,
    USER_POOL_CLIENT_ID: import.meta.env.VITE_USER_POOL_CLIENT_ID,
    REGION: import.meta.env.VITE_REGION
  };
}
